import { __extends } from "tslib";
import { addPrototypeFunctionAlias } from './addPrototypeFunctionAlias';
import { ASObject } from './ASObject';
var ASBoolean = /** @class */ (function (_super) {
    __extends(ASBoolean, _super);
    function ASBoolean() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ASBoolean.classInitializer = function () {
        var proto = this.dPrototype;
        var asProto = ASBoolean.prototype;
        addPrototypeFunctionAlias(proto, '$BgtoString', asProto.toString);
        addPrototypeFunctionAlias(proto, '$BgvalueOf', asProto.valueOf);
    };
    ASBoolean.prototype.toString = function () {
        return this.value.toString();
    };
    ASBoolean.prototype.valueOf = function () {
        return this.value.valueOf();
    };
    return ASBoolean;
}(ASObject));
export { ASBoolean };
